export const OFFER_PAGE_LOCALE_ROOT = "paywall_checkout.offer_page";
